export default __webpack_public_path__ + "static/media/tex-gyre-adventor-regular.5ef0cb89.woff";